import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import {
  appendSellerSupportMessageToCache,
  CHAT_UNREAD_QUERY_KEY,
  getActiveAdminChatSellerId,
} from '../chat-cache';
import { useSellerSupportChatSocket } from '../hooks/useSellerSupportChatSocket';
import { showSupportChatIncomingToast } from '../support-chat-toast';

type SellerSupportChatToastListenerProps = {
  enabled?: boolean;
};

/** Единственный источник тостов о сообщениях продавца. */
export function SellerSupportChatToastListener({
  enabled = true,
}: SellerSupportChatToastListenerProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useSellerSupportChatSocket(
    {
      onMessage: ({ sellerId, shopName, message }) => {
        if (message.senderKind !== 'SELLER') return;
        appendSellerSupportMessageToCache(queryClient, sellerId, message, { shopName });
        if (getActiveAdminChatSellerId() === sellerId) return;
        showSupportChatIncomingToast({
          title: 'Сообщение в поддержку - продавец',
          body: message.body,
          imageCount: message.imageUrls?.length ?? 0,
          messageId: message.id,
          onOpen: () => navigate(`/sellers/support-chat?sellerId=${sellerId}`),
        });
      },
      onUnread: ({ scope, count, sellerId }) => {
        if (scope !== 'admin') return;
        if (sellerId != null && getActiveAdminChatSellerId() === sellerId) return;
        queryClient.setQueryData(CHAT_UNREAD_QUERY_KEY, { count });
      },
    },
    enabled,
  );

  return null;
}
